// extracted by css-extract-rspack-plugin
export default {"root":"TefAqS","stats":"MNUlBl","boosted":"cadA1q","boosted-text":"szt4tZ","boostedText":"szt4tZ"};